import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export function Card({
  children,
  className = '',
  onClick
}: CardProps) {
  return <div className={`bg-white rounded-lg border border-slate-200 shadow-sm ${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''} ${className}`} onClick={onClick} data-id="element-178">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`px-6 py-4 border-b border-slate-100 ${className}`} data-id="element-179">
      {children}
    </div>;
}
export function CardTitle({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h3 className={`text-lg font-semibold text-slate-900 ${className}`} data-id="element-180">
      {children}
    </h3>;
}
export function CardContent({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`p-6 ${className}`} data-id="element-181">{children}</div>;
}
export function CardFooter({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`px-6 py-4 bg-slate-50 border-t border-slate-100 rounded-b-lg ${className}`} data-id="element-182">
      {children}
    </div>;
}